export const DAUMBLOG = 'blog'
export const TISTORY = 'tistory'
